import React from "react";
import { Badge, BadgeProps } from "./badge";
import { cn } from "@/lib/utils";

export interface NotificationBadgeProps extends BadgeProps {
  label?: string | number;
  show?: boolean;
  max?: number; // optional: to customize max display (e.g., 9+ or 99+)
}

export const NotificationBadge = ({
  label,
  className,
  show,
  children,
  max = 99,
  ...props
}: NotificationBadgeProps) => {
  const isDefined = typeof label !== "undefined";
  const isVisible = typeof show === "undefined" || show;

  const getDisplayLabel = () => {
    if (typeof label === "number") {
      return label > max ? `${max}+` : label.toString();
    }
    if (typeof label === "string" && !isNaN(Number(label))) {
      const numeric = Number(label);
      return numeric > max ? `${max}+` : numeric.toString();
    }
    return label?.toString() ?? "";
  };

  const displayLabel = getDisplayLabel();

  const showBadge = isDefined && isVisible;

  const isDotOnly = displayLabel.length === 0;

  return (
    <div className="inline-flex relative">
      {children}
      {showBadge && (
        <Badge
          className={cn(
            "absolute top-0 right-0 rounded-full h-[18px] w-[18px] p-0 flex justify-center items-center",
            isDotOnly
              ? "translate-x-1 -translate-y-1 px-1.5 py-1.5"
              : "translate-x-1.5 -translate-y-1.5 px-2",
            className,
          )}
          {...props}
        >
          {displayLabel}
        </Badge>
      )}
    </div>
  );
};
